enum Status {
  DEMO,
  ONBOARDING,
  DONE
}

export default Status;
